<template>
  <div v-if="this.$store.state.server">
    <h4>Check Time</h4>
    <p class="error">{{ error }}</p>
    <b-row>
      <b-col>QR :</b-col>
      <b-col>
        <b>{{ result }}</b>
      </b-col>
    </b-row>
    {{test}}
    <!-- <b-button variant="outline-primary" @click="posttime('001')">test</b-button> -->
    <qrcode-stream @decode="onDecode" @init="onInit" />
  </div>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";

export default {
  components: { QrcodeStream },

  data() {
    return {
      selected: "goods8",
      result: "",
      error: "",
      test: "",
      price: 0
    };
  },

  methods: {
    onDecode(result) {
      if (result == "") return;
      this.result = result;
      this.posttime(result);
    },
    posttime(qr) {
      const formData = new FormData();
      formData.append("api", "checktime");
      formData.append("qr", qr);
      axios
        .post(this.$store.state.api, formData)
        .then(response => {
          // console.log(response.data)
          this.$parent.showAlert(response.data.data, "success");
          this.result = response.data.data;
          // this.$router.replace({
          //   name: "home"
          // });
        })
        .catch(e => {});
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "ERROR: you need to grant camera access permisson";
        } else if (error.name === "NotFoundError") {
          this.error = "ERROR: no camera on this device";
        } else if (error.name === "NotSupportedError") {
          this.error = "ERROR: secure context required (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "ERROR: is the camera already in use?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "ERROR: installed cameras are not suitable";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "ERROR: Stream API is not supported in this browser";
        }
      }
    }
  }
};
</script>

<style scoped>
.error {
  font-weight: bold;
  color: red;
}
</style>